import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeGateway } from '@tectonics/prs/core/gateway';

export function getGatewayPaymentCode(incomingPayment: PendingIncomingPayment): string | null | undefined {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['payment_code'];
}

export function getSafeGatewayPaymentCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayPaymentCode(incomingPayment);

  if (!code) {
    throw new Error('getSafeGatewayPaymentCode - there is no payment code in the incoming payment');
  }

  return code;
}
